"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EPaceType = exports.EPaceMarkType = void 0;
var EPaceMarkType;
(function (EPaceMarkType) {
    EPaceMarkType[EPaceMarkType["SATISFACTORY"] = 1] = "SATISFACTORY";
    EPaceMarkType[EPaceMarkType["BORDERLINE"] = 2] = "BORDERLINE";
    EPaceMarkType[EPaceMarkType["UN_SATISFACTORY"] = 3] = "UN_SATISFACTORY";
})(EPaceMarkType = exports.EPaceMarkType || (exports.EPaceMarkType = {}));
var EPaceType;
(function (EPaceType) {
    EPaceType[EPaceType["ALL"] = 0] = "ALL";
    EPaceType[EPaceType["ABDOMINAL"] = 1] = "ABDOMINAL";
    EPaceType[EPaceType["CARDIOVASCULAR"] = 2] = "CARDIOVASCULAR";
    EPaceType[EPaceType["COMMUNICATION"] = 3] = "COMMUNICATION";
    EPaceType[EPaceType["CONSULTATION"] = 4] = "CONSULTATION";
    EPaceType[EPaceType["NEUROLOGY"] = 5] = "NEUROLOGY";
    EPaceType[EPaceType["RESPIRATORY"] = 6] = "RESPIRATORY";
})(EPaceType = exports.EPaceType || (exports.EPaceType = {}));
